import { NgFor, NgIf } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  Input,
  afterNextRender,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DynamicModule } from 'ng-dynamic-component';
import { StoryblokDirective } from 'src/app/directive/storyblok.directive';
import { Components } from 'src/app/storyblok/components';

declare global {
  interface Window {
    storyblok: any;
  }
}

@Component({
  selector: 'app-storyblok',
  imports: [NgFor, DynamicModule, StoryblokDirective],
  templateUrl: './storyblok.component.html',
  styleUrl: './storyblok.component.scss',
})
export class ContentSourceStoryblokComponent {
  story: { content: any; name: string } = { content: null, name: '' };
  components: any = Components;
  @Input() _editable!: string;

  constructor(private route: ActivatedRoute, private cd: ChangeDetectorRef) {
    afterNextRender(() => {
      try {
        window.storyblok.on('input', (event: any) => {
          if (
            this.story &&
            event.story.content._uid === this.story?.content?._uid
          ) {
            this.story = event.story;
            this.cd.markForCheck();
          }
        });
      } catch (err) {
        console.log('not in visual editor');
      }
    });

    this.route.data.subscribe((data: any) => {
      this.story = data?.page?.story;
    });
  }

  trackByFn(index: number, item: any): any {
    return item._uid; // or another unique identifier for your components
  }
}
